import { CheckCheck, PartyPopper, SendHorizonalIcon, Trash2 } from 'lucide-react';
import moment from 'moment';
import React from 'react';
import icEmpire from "../assets/logos/logo-empire-str.png";
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';

const TalkTypeWaitAskPaiement = ({ m, deleteMessage, init, setNotifTalk }) => {
    const userToken = infoUser()
    const { projectJson, socket } = useSocket()
    const changeMessage = async (t, t_msg) => {
        socket.emit('empire_change_message', { token: userToken.expecttoken, nameAdmin: userToken.name, idMessage: m.id, type: t, status: "Envoyé" }, (e) => {
        })
        const payloadSend = { token: userToken.expecttoken, message: null, idUser: m.user_id, nameAdmin: userToken.name, type: t_msg }

        socket.emit('empire_change_status_paiement', { token: userToken.expecttoken, idUser: m.user_id, status: "wait" }, (e) => {

        })
        socket.emit(
            'empire_send_message_user',
            { ...payloadSend },
            (e) => {
                console.log(e);

                if (e.isSend) {
                    setNotifTalk({ txt: `Message Envoyé - (${e.status})`, c: "bcs cb" })
                    init()
                } else {
                    setNotifTalk({ txt: `Erreur`, c: "bce cww" })
                }
            }
        );
    }
    return (
        <div className='df fdc aic jcc w100 bcw py2 px1' style={{ borderRadius: "10px" }}>
            <div className='df aic jcsb w100'>
                <div className='df aic gap1'>
                    <div className='c-avatar'>
                        {m.role == "user" && (
                            <img className='avatar' src={projectJson?.href + "/images/users/" + m.path}></img>
                        )}
                    </div>
                    <div className='df fdc'>
                        <div className='df gap1 aic'>
                            <SendHorizonalIcon color={'#0074dc'} size={20} />
                            <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date).fromNow()}</p>
                        </div>
                        {m.status == "Lu" && (
                            <div className='df gap1 aic'>
                                <CheckCheck color={'#0074dc'} size={20} />
                                <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date_read).fromNow()}</p>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    <button onClick={deleteMessage}><Trash2 color='#f71717' size={20} /></button>
                </div>
            </div>

            <p className='fb cb fs1 tac py1'>Demande de paiement</p>
            <p className='fr cgrey tac '>Vous devez envoyer la demande de paiement</p>
            <div className='df gap1 mt2'>
                <button onClick={() => changeMessage('paiement_ask_accept', "paiement_ask_received")} className='px2 cp bcs cw fr br10  py1'>Accepter</button>
                <button onClick={() => changeMessage('paiement_ask_refuse', "paiement_ask_received_refuse")} className='px2 cp bcgrey cw fr  br10  py1'>Refuser</button>
            </div>
        </div>
    );
};

export default TalkTypeWaitAskPaiement;